export default "__VITE_ASSET__C14v_HDt__"